import { render, staticRenderFns } from "./AboutUsTabs.vue?vue&type=template&id=637fa299&scoped=true&"
import script from "./AboutUsTabs.vue?vue&type=script&lang=js&"
export * from "./AboutUsTabs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsTabs.vue?vue&type=style&index=0&id=637fa299&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637fa299",
  null
  
)

export default component.exports